import { useId, useState } from "react";
import styles from "./stock-card.module.css";

const TONE = {
  positive: { color: "var(--positive)" },
  neutral:  { color: "var(--neutral)" },
  negative: { color: "var(--negative)" },
};
const scoreTone = (s) => (s == null ? "neutral" : s >= 7.5 ? "positive" : s >= 6 ? "neutral" : "negative");

// ── Quality pillars (all 8 keys; higher = better everywhere) ────────────
// Computed deterministically from financial data (see fmp/calculations.py),
// not an LLM judgement call - each field's docstring in
// fmp/models/qualitative_rating.py documents its exact weight breakdown.
export const PILLARS = [
  {
    id: "moat",
    name: "Moat & Position",
    keys: [
      { key: "CompetitiveAdvantage", label: "Competitive Advantage" },
      { key: "MarketPosition",       label: "Market Position" },
      { key: "CustomerQuality",      label: "Customer Quality" },
    ],
  },
  {
    id: "quality",
    name: "Business Quality",
    keys: [
      { key: "BusinessModel",      label: "Business Model" },
      { key: "CapitalEfficiency",  label: "Capital Efficiency" },
      { key: "IndustryQuality",    label: "Industry Quality" },
    ],
  },
  {
    id: "risk",
    name: "Risk & Governance",
    keys: [
      { key: "Resilience",            label: "Resilience" },
      { key: "ManagementGovernance",  label: "Management & Governance" },
    ],
  },
];

export const Pillar = ({ pillar, qual }) => {
  const [open, setOpen] = useState(false);
  const detailsId = useId();
  const values = pillar.keys.map((k) => qual[k.key]).filter((v) => v != null);
  if (values.length === 0) return null;
  const avg = values.reduce((a, b) => a + b, 0) / values.length;
  const tone = TONE[scoreTone(avg)];
  return (
    <div className={styles.pillar}>
      <button
        type="button"
        className={styles.pillarHeader}
        aria-expanded={open}
        aria-controls={detailsId}
        onClick={() => setOpen((o) => !o)}
      >
        <div className={styles.pillarTitle}>
          <span className={styles.pillarName}>{pillar.name}</span>
          <span className={styles.pillarMeta}>
            {values.length} {values.length === 1 ? "factor" : "factors"} · tap to {open ? "hide" : "view"}
          </span>
        </div>
        <div className={styles.pillarRight}>
          <div className={styles.pillarBar}>
            <span
              className={styles.pillarBarFill}
              style={{ width: `${(avg / 10) * 100}%`, background: tone.color }}
            />
          </div>
          <span className={styles.pillarScore} style={{ color: tone.color }}>
            {avg.toFixed(1)}
          </span>
        </div>
      </button>
      {open && (
        <div id={detailsId} className={styles.pillarDetails}>
          {pillar.keys.map(({ key, label }) => {
            const v = qual[key];
            if (v == null) return null;
            const barTone = TONE[scoreTone(v)];
            return (
              <div key={key} className={styles.ratingRow}>
                <span className={styles.ratingLabel}>{label}</span>
                <div className={styles.ratingBar}>
                  <span
                    className={styles.ratingBarFill}
                    style={{ width: `${(v / 10) * 100}%`, background: barTone.color }}
                  />
                </div>
                <span className={styles.ratingValue}>{v}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
